import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=9ca035ba"
import script from "@/controllers/custom/route/route-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/route/route-list.js?vue&type=script&lang=js&external"
import style0 from "./RouteList.vue?vue&type=style&index=0&id=9ca035ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports